export default __webpack_public_path__ + "static/media/MiturLogo.18abda64.png";